import { useQuery } from '@tanstack/react-query';
import * as api from 'util/api.js';

/** Query key for GET /pricing/discrepancies/overview (name kept for existing invalidations). */
export const PRICING_DISCREPANCY_SCAN_KEY = ['pricing_discrepancy_scan'];
export const PRICING_DISCREPANCY_BEER_KEY = ['pricing_discrepancy_beer'];

/** Overview + any open beer-detail drawer. Prefix match covers all beer keys. */
export function invalidatePricingDiscrepancyQueries(queryClient) {
  queryClient.invalidateQueries({ queryKey: PRICING_DISCREPANCY_SCAN_KEY });
  queryClient.invalidateQueries({ queryKey: PRICING_DISCREPANCY_BEER_KEY });
}

/**
 * Live overview of pricing discrepancies (slim beers + summary).
 */
export default function usePricingDiscrepancyOverviewQuery(includeLegacy) {
  return useQuery({
    queryKey: [...PRICING_DISCREPANCY_SCAN_KEY, includeLegacy ? 'legacy' : 'active'],
    queryFn: () => api.getPricingDiscrepancyOverview({
      includeLegacy: includeLegacy ? 1 : undefined,
    }),
    staleTime: 60 * 1000,
  });
}

/**
 * Full beer detail for the resolver drawer.
 */
export function usePricingDiscrepancyBeerQuery(beerKey, enabled, includeLegacy) {
  return useQuery({
    queryKey: [...PRICING_DISCREPANCY_BEER_KEY, beerKey, includeLegacy ? 'legacy' : 'active'],
    queryFn: () => api.getPricingDiscrepancyBeer(beerKey, {
      includeLegacy: includeLegacy ? 1 : undefined,
    }),
    enabled: Boolean(enabled && beerKey != null),
  });
}
